import { SIDEBAR_MOBILE_BREAKPOINT } from '@constants/sidebar';

export const TILE_PX = 184;
export const TILE_OPEN_PX = 268;
export const TILE_PHONE_PX = 136;
export const TILE_GAP_PX = 12;
export const TILE_RADIUS_PX = 14;

// Touch screens get no hover state, so tiles never widen or reveal there.
export const HOVER_MEDIA = `@media (hover: hover) and (min-width: ${SIDEBAR_MOBILE_BREAKPOINT + 1}px)`;

// Above the Process editor's sticky top bar (900), below the menu's expand handle (1100).
export const GALLERY_Z_INDEX = 1000;

export const FOOTER_VIEW_APPS = 'apps';
export const FOOTER_VIEW_MARKETPLACE = 'marketplace';
export type FooterView = typeof FOOTER_VIEW_APPS | typeof FOOTER_VIEW_MARKETPLACE;

export const ALL_TAB = 'all';
